import Vue from 'vue'
import axios from 'axios'
import VueMeta from 'vue-meta'
import ToggleButton from 'vue-js-toggle-button'
import VModal from 'vue-js-modal'
import Vue2Filters from 'vue2-filters'
import VuePaginate from 'vue-paginate'
import VTooltip from 'v-tooltip'
import App from './app.vue'
import router from './routes'
import VueContentPlaceholders from 'vue-content-placeholders'

// Проверка авторизации
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) 
{
  if (401 === error.response.status) {
      router.push({name: 'account/login'});
  }
  
  return Promise.reject(error);
});

// Отправка заголовка авторизации
axios.interceptors.request.use(function (config) {

  const token = localStorage.token;

  if(token && token.length > 0)
    config.headers.Authorization = 'Bearer '+token;

  return config;
});

// Быстрый доступ к axios
Vue.prototype.$axios = axios

Vue.config.productionTip = false

// Мета-теги
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

// Переключатели
Vue.use(ToggleButton);

// Определение фокуса
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
});

// Маска ввода
Vue.use(require('vue-inputmask').default);

// Модальные окна
Vue.use(VModal, {
  dynamic: true, 
  injectModalsContainer: true,
  dynamicDefaults: {
    height:    'auto',
    draggable: false,
    scrollable: true,
    adaptive: false
  }
})

// Фильтры
Vue.use(Vue2Filters)

// Постраничная навигация
Vue.use(VuePaginate)

// Подсказки
Vue.use(VTooltip)

// Подмена контента
Vue.use(VueContentPlaceholders)

// Приложение
new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app');